import { QBox } from '@qualio/ui-components';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { documentApi } from '../../../api/document';
import { DocumentPresentationUtils } from '../../../util/DocumentPresentationUtils';

export const EmbedDocument: React.FC = () => {
  const { t } = useTranslation();
  const { id, companyId } = useParams();

  const loadDocument = useCallback(async () => {
    try {
      const fetchedDocument = await documentApi.fetchDocumentExportPayload(
        id as string,
        Number(companyId),
      );
      const exportPayload = fetchedDocument.exports[0];
      const documentHtml = DocumentPresentationUtils.convertEmbedsToLinks(
        exportPayload.html,
        true,
      );
      const documentHtmlWithoutToc =
        DocumentPresentationUtils.removeTableOfContentsFromHtml(documentHtml);
      return {
        ...exportPayload,
        html: documentHtmlWithoutToc,
      };
    } catch (e: any) {
      console.error(e);
    }
  }, [id, companyId]);

  const {
    isLoading: isLoadingDocument,
    isFetching: isFetchingDocument,
    data: qualioDocument,
  } = useQuery({
    queryKey: ['newDocument', id],
    queryFn: loadDocument,
    refetchOnWindowFocus: false,
    enabled: Boolean(id),
  });
  useEffect(() => {
    if (!qualioDocument) return;

    const sendHeightMessage = () => {
      window.parent.postMessage(
        {
          iframeHeight: document.body.scrollHeight + 10,
          id: id,
        },
        process.env.REACT_APP_FRONTEND_HOSTNAME ?? '',
      );
    };

    sendHeightMessage();

    const resizeObserver = new ResizeObserver(() => {
      sendHeightMessage();
    });

    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, [qualioDocument, id]);

  if (!id) {
    return <div>{t('messages.invalidDocumentId')}</div>;
  }

  if (isLoadingDocument || isFetchingDocument || !qualioDocument) {
    return <div>{t('labels.loading')}</div>;
  }

  return (
    <QBox
      className="ck-content non-editable-mode document"
      data-code={qualioDocument.header.top_right}
    >
      <QBox dangerouslySetInnerHTML={{ __html: qualioDocument.html }} />
    </QBox>
  );
};
